import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class ReqnoService {
  private apiUrl = '/reqnos';
  private apiSpringUrl = '/spring/reqnos';

  constructor(private http: HttpService) { }

  get(ownerId: number): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}?ownerId=${ownerId}`;
    return this.http.get(url);
  }

  post(
    ownerId: number,
    reqmngCd: string,
    carrierCd: string,
    startreqnoNr: number,
    endreqnoNr: number,
    orderNr: number,
    updprogramCd: string
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}`;
    const jsonInput = {
      ownerId: ownerId,
      reqmngCd: reqmngCd,
      carrierCd: carrierCd,
      startreqnoNr: startreqnoNr,
      endreqnoNr: endreqnoNr,
      orderNr: orderNr,
      updprogramCd: updprogramCd
    };

    return this.http.post(url, jsonInput);
  }

  delete(
    ownerId: number,
    reqmngCd: string,
    orderNr: number,
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/${ownerId}/${reqmngCd}/${orderNr}`;
    return this.http.delete(url);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/reqno/reqno.service.ts